"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { Skeleton } from '../../ui-kit/skeleton.mjs';

const IntegrationItemSkeleton = forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ref,
        className: clsx(
          "flex flex-col justify-start items-center gap-2 p-3 pt-5 rounded-md min-h-28 bg-white whitespace-normal",
          className
        ),
        ...props,
        children: [
          /* @__PURE__ */ jsx(Skeleton, { className: "rounded-full", children: /* @__PURE__ */ jsx("div", { className: "w-10 h-10 rounded-full" }) }),
          /* @__PURE__ */ jsx(Skeleton, { className: "h-4 w-3/5" })
        ]
      }
    );
  }
);

export { IntegrationItemSkeleton };
